/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var Captcha = /** @class */ (function () {
    function Captcha() {
        this.error = 0;
        this.left = "10";
        this.showInstruction = true;
        this.showMenu = true;
        this.showError = true;
        this.errorMessage = "";
        this.instructionsInside = false;
        this.inputWidth = 245;
        this.done = false;
        this.holder = "ms_captcha_holder";
        this.scriptHolder = "ms_captcha_scriptholder";
        this.count = 0;
        this.type = "visual";
        this.market = "en-us";
    }
    Captcha.prototype.getInstruction = function () { };
    Captcha.prototype.getMenu = function () { };
    Captcha.prototype.getError = function () {
        return null;
    };
    Captcha.prototype.getSolution = function () { };
    Captcha.prototype.reloadHIP = function () { };
    Captcha.prototype.switchHIP = function () { };
    Captcha.prototype.clientValidation = function () { };
    Captcha.prototype.setError = function () {
        return null;
    };
    Captcha.prototype.setFocus = function () { };
    Captcha.prototype.verify = function (callback, param) { };
    Captcha.prototype.instructionOutsideCallback = function (instruction) {
        this.instructionCallback(instruction);
    };
    Captcha.prototype.menuOutsideCallback = function (menu) {
        this.refreshOutsideMenu(menu);
    };
    Captcha.prototype.showErrorCallback = function (message) {
        var ele = document.getElementById("idError");
        if (ele) {
            ele.innerHTML = message;
        }
    };
    Captcha.prototype.removeErrorCallback = function () {
        var ele = document.getElementById("idError");
        if (ele) {
            ele.innerHTML = "";
        }
    };
    Captcha.prototype.postLoad = function () {
        var inputId = this.setError();
        var messageText = this.getError();
        if (messageText && inputId) {
            var captchaInput = document.getElementById(inputId);
            if (captchaInput) {
                captchaInput.focus();
            }
        }
    };
    Captcha.prototype.verifyCallback = function (solution, token, param) {
        this.clientValidation();
        if (this.error != 0) {
            return;
        }
        document.getElementById("Solution").value = solution;
        document.getElementById("Token").value = token;
        document.getElementById("Type").value = this.type;
        return;
    };
    Captcha.prototype.refreshOutsideMenu = function (menu) {
        for (var i = 0; i < 4; i++) {
            var ele = document.getElementById("idMenu" + i);
            if (!ele)
                return;
            ele.innerHTML = "";
            ele.title = "";
            ele.onclick = function () { };
        }
        var itemLength = menu.length;
        if (!this.showMenu) {
            var _loop_1 = function (j) {
                var ele = document.getElementById("idMenu" + j);
                if (!ele)
                    return { value: void 0 };
                ele.innerHTML = menu[j].text;
                ele.title = menu[j].tip;
                var trigger = menu[j].trigger;
                ele.onclick = function () {
                    trigger();
                    return false;
                };
            };
            for (var j = 0; j < itemLength; j++) {
                var state_1 = _loop_1(j);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
    };
    Captcha.prototype.instructionCallback = function (instruction) {
        if (this.showInstruction) {
            var ins_1 = document.getElementById("idInstruction");
            if (ins_1) {
                ins_1.innerHTML = "";
            }
            return;
        }
        var ins = document.getElementById("idInstruction");
        if (ins) {
            ins.innerHTML = instruction;
        }
    };
    Captcha.prototype.reloadCaptchaAndShowError = function (error) {
        this.reloadHIP();
        this.error = error;
        this.setError();
    };
    return Captcha;
}());
export { Captcha };
